// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".semi-collapsible-transition{transition:height 250ms cubic-bezier(0.25, 0.1, 0.25, 1) var(--semi-transition_delay-none),opacity 250ms var(--semi-transition_function-easeIn) var(--semi-transition_delay-none)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
